import { useExecutiveQuery } from 'features/executive/shared/hooks/use-executive-query'
import PerformanceApi from 'api/executive/performance.api'
import type {
  ExecutiveFilterState,
  GetPerBranchRevenueParams,
  GetPerBranchRevenueResponse,
} from 'api/executive/executive.types'

// Per-branch revenue table. Deliberately ignores filter.branchId — this
// widget's purpose is the all-branches comparison view.
export function usePerBranchRevenue(scopedFilters?: Partial<ExecutiveFilterState>) {
  return useExecutiveQuery<GetPerBranchRevenueParams, GetPerBranchRevenueResponse>(
    'performance.per-branch-revenue',
    PerformanceApi.getPerBranchRevenue,
    (f) => {
      if (!f.dateRange?.start || !f.dateRange?.end) return null
      return {
        dateFrom: f.dateRange.start,
        dateTo: f.dateRange.end,
        doctorId: f.doctorId ?? undefined,
        procedureId: f.procedureId ?? undefined,
        patientType: f.patientType ?? undefined,
      }
    },
    { scopedFilters }
  )
}
